import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Logo from './Logo';
import UserDropdown from './UserDropdown';
import LoginOverlay from './LoginOverlay';
import sessionManager from '../utils/sessionManager';
import './SiteHeader.css';

const SiteHeader = () => {
  const navigate = useNavigate();
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [showLogin, setShowLogin] = useState(false);
  const [loginMode, setLoginMode] = useState('signin');

  useEffect(() => {
    const checkAuth = () => setIsAuthenticated(sessionManager.isAuthenticated());
    checkAuth();
    window.addEventListener('storage', checkAuth);
    return () => window.removeEventListener('storage', checkAuth);
  }, []);

  const handleShowLoginModal = (mode) => {
    setLoginMode(mode);
    setShowLogin(true);
  };

  const handleCloseLoginModal = () => {
    setShowLogin(false);
    setIsAuthenticated(sessionManager.isAuthenticated());
  };

  return (
    <>
      {showLogin && (
        <LoginOverlay initialMode={loginMode} onClose={handleCloseLoginModal} />
      )}

      <header className="site-header">
        <div className="site-header__container">
          <Logo 
            size={53} 
            showText={true} 
            variant="dark" 
            onClick={() => navigate('/')}
          />
          <div className="site-header__actions">
            {isAuthenticated ? (
              <UserDropdown />
            ) : (
              <>
                <button onClick={() => handleShowLoginModal('signin')} className="site-header__signin">
                  Sign In
                </button>
                <button onClick={() => handleShowLoginModal('signup')} className="site-header__signup">
                  Sign Up
                </button>
              </>
            )}
          </div>
        </div>
      </header>
    </>
  );
};

export default SiteHeader;


